'use strict';

var React = require('react');

const LinkContext = /*#__PURE__*/React.createContext(undefined);

exports.LinkContext = LinkContext;
